import { render } from "./DyAccountManagement.vue?vue&type=template&id=29985c5c&scoped=true"
import script from "./DyAccountManagement.vue?vue&type=script&lang=js"
export * from "./DyAccountManagement.vue?vue&type=script&lang=js"

import "./DyAccountManagement.vue?vue&type=style&index=0&id=29985c5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29985c5c"]])

export default __exports__